import PropTypes from 'prop-types';
import CharacterCounter from 'apps/interactions/components/character-counter';
import { useProposalFormContext } from '../context/proposal-form-context';

const { PROPOSAL_CHARACTER_LIMIT } = require('apps/proposals/utils');

const DescriptionField = ({ onChange, onBlur, name = '', value = '', required = false, field, meta, helpers }) => {
  const { standardFieldsConfig } = useProposalFormContext();
  const maxLength = standardFieldsConfig?.description?.max_length;
  const defaultMaxLength = PROPOSAL_CHARACTER_LIMIT?.DESCRIPTION;

  return (
    <>
      <textarea
        id={name}
        rows="4"
        aria-label="description"
        name={name}
        value={value || ''}
        placeholder={'Add description...'}
        onChange={onChange}
        onBlur={onBlur}
        // maxLength={maxLength} this seems like the easiest and best way to handle max length validation but :shrug:
      />

      {maxLength < defaultMaxLength && <CharacterCounter limit={maxLength} count={(value || '').length} />}
    </>
  );
};

DescriptionField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default DescriptionField;
